(function(){
'use strict';

/* ─── Data ─────────────────────────────────────────── */
var SIZES = [
  {id:'67580634071319', label:'30 mL', lasts:'On the go', price:24.95, days:52},
  {id:'51799582605591', label:'60 mL', lasts:'Three months or more', price:39.95, days:105},
  {id:'67580634104087', label:'250 mL', lasts:'For the super fans', price:79.95, days:437}
];
var STOCK = ['preorder','in','preorder'];
var DISC = [0, 0.06, 0.125];
var SHIP = "10 Dec 26\u2019";
var BLURB = ['Try it','Bag and bathroom','Household-proof'];
var REPLACES = ['Lip balm','Hand cream','Cuticle oil','Heel & elbow balm','Post-shave balm','Nipple balm','Nappy balm','Overnight mask','Petroleum jelly','The tube of ointment you\u2019re not sure is still in date'];
var GALLERY_TYPES = ['image','video','image','image','image'];

/* ─── State ────────────────────────────────────────── */
var S = {
  gallery: 0,
  size: 1,
  qty: 0,
  mode: 'simple',
  mix: [0, 1, 0],
  sizesOpen: false,
  mathSize: 1,
  drawer: false,
  sound: -1
};

/* ─── Helpers ──────────────────────────────────────── */
var $ = function(s,p){return (p||document).querySelector(s)};
var $$ = function(s,p){return (p||document).querySelectorAll(s)};
var money = function(n){return '$'+n.toFixed(2)};
var round95 = function(x){return Math.round(x-0.95)+0.95};
var rateFor = function(n){return n>=3?DISC[2]:n>=2?DISC[1]:0};
var statusText = function(st){return st==='in'?'In stock':st==='low'?'3 left':st==='preorder'?'Pre-order \u00b7 '+SHIP:'Sold out'};
var dotColor = function(st){return (st==='in'||st==='low')?'#a8b8a0':'#c9cbd1'};
var dotColorGreen = function(st){return (st==='in'||st==='low')?'#7fc97a':'#c9cbd1'};

/* ─── Gallery ──────────────────────────────────────── */
function renderGallery(){
  var heroImg = $('#pdpv3-hero-img');
  var heroVid = $('#pdpv3-hero-vid');
  var thumbs = $$('[data-gallery]');
  if(!heroImg) return;
  var isVideo = GALLERY_TYPES[S.gallery] === 'video';
  heroImg.style.display = isVideo ? 'none' : 'block';
  heroVid.style.display = isVideo ? 'block' : 'none';
  if(!isVideo){
    var srcs = [heroImg.getAttribute('data-src0'),null,heroImg.getAttribute('data-src2'),heroImg.getAttribute('data-src3'),heroImg.getAttribute('data-src4')];
    heroImg.src = srcs[S.gallery] || heroImg.getAttribute('data-src0');
  }
  thumbs.forEach(function(t){
    t.style.opacity = parseInt(t.dataset.gallery)===S.gallery ? '1' : '.55';
  });
}

/* ─── Product Title Sizing ─────────────────────────── */
function fitTitle(){
  var el = $('#pdpv3-product-title');
  if(!el||!el.parentElement) return;
  var avail = el.parentElement.clientWidth;
  if(avail<=0) return;
  el.style.fontSize = '100px';
  var w = el.getBoundingClientRect().width;
  if(w>0) el.style.fontSize = (100*avail/w).toFixed(2)+'px';
}

/* ─── Bundle Selector ──────────────────────────────── */
function renderSelector(){
  var el = $('#pdpv3-selector');
  if(!el) return;
  var sz = SIZES[S.size], st = STOCK[S.size];
  var mixing = S.mode==='mix';
  var headOut = st==='out';
  var count = mixing ? S.mix.reduce(function(a,b){return a+b},0) : (headOut?0:S.qty+1);
  var sub = mixing ? S.mix.reduce(function(a,q,i){return a+q*SIZES[i].price},0) : sz.price*(S.qty+1);
  var rate = mixing ? rateFor(count) : DISC[S.qty];
  var total = count ? round95(sub*(1-rate)) : 0;
  var save = count ? Math.max(0, sub - total) : 0;
  var preIn = mixing ? S.mix.some(function(q,i){return q>0&&STOCK[i]==='preorder'}) : st==='preorder';
  var disabled = count===0||(!mixing&&headOut);

  var h = '';

  /* Header */
  h += '<div id="buy" style="display:flex;flex-direction:column;gap:20px">';
  h += '<div style="border-top:1.5px solid #151212;border-bottom:1.5px solid #151212">';
  h += '<div style="display:flex;justify-content:space-between;align-items:center;gap:12px;padding:14px 0">';
  h += '<span style="display:flex;flex-direction:column;gap:2px">';
  var sizeLabel = mixing ? 'Mixed sizes' : sz.label+' tin';
  var sizeSub = mixing ? (S.mix.map(function(q,i){return q?q+' \u00d7 '+SIZES[i].label:null}).filter(Boolean).join(' + ')||'Nothing yet') : money(sz.price)+' \u00b7 '+sz.lasts;
  var statusStr = mixing ? count+(count===1?' tin':' tins') : statusText(st);
  var dot = mixing ? (preIn?'#c9cbd1':'#a8b8a0') : dotColor(st);
  h += '<span style="display:flex;align-items:center;gap:10px"><span style="font-weight:700;font-size:17px;letter-spacing:-0.02em">'+sizeLabel+'</span><span style="display:flex;align-items:center;gap:6px;font-family:\'Fragment Mono\',monospace;font-size:11px;letter-spacing:0.06em;color:#6e6a68"><span style="width:6px;height:6px;border-radius:50%;background:'+dot+'"></span>'+statusStr+'</span></span>';
  h += '<span style="font-size:14px;color:#6e6a68">'+sizeSub+'</span>';
  h += '</span>';
  h += '<button data-action="toggle-sizes" style="display:inline-flex;align-items:center;gap:8px;min-height:44px;padding:0 16px;background:none;border:1.5px solid #151212;border-radius:999px;color:#151212;font-size:14px;font-weight:500;white-space:nowrap;font-family:inherit;cursor:pointer"><span>'+(S.sizesOpen?'Done':'Change size')+'</span><span style="font-family:\'Fragment Mono\',monospace;font-size:12px;display:inline-block;transform:'+(S.sizesOpen?'rotate(180deg)':'none')+';transition:transform 220ms cubic-bezier(.2,.6,.2,1)">\u2335</span></button>';
  h += '</div>';

  /* Size reveal */
  if(S.sizesOpen){
    h += '<div style="display:flex;flex-direction:column;border-top:1px solid #c9cbd1">';
    for(var i=0;i<SIZES.length;i++){
      if(i===S.size) continue;
      h += '<button data-action="select-size" data-value="'+i+'" style="display:flex;justify-content:space-between;align-items:center;gap:12px;width:100%;padding:12px 0;background:none;border:none;border-bottom:1px solid #c9cbd1;color:#151212;text-align:left;font-family:inherit;cursor:pointer">';
      h += '<span style="display:flex;flex-direction:column;gap:2px"><span style="font-weight:700;font-size:16px;letter-spacing:-0.02em">'+SIZES[i].label+' <span style="font-weight:400;color:#6e6a68;font-size:14px">'+money(SIZES[i].price)+'</span></span><span style="font-size:14px;color:#6e6a68">'+SIZES[i].lasts+'</span></span>';
      h += '<span style="font-family:\'Fragment Mono\',monospace;font-size:11px;letter-spacing:0.06em;color:#6e6a68;white-space:nowrap">'+statusText(STOCK[i])+'</span>';
      h += '</button>';
    }
    h += '<div style="display:flex;justify-content:space-between;align-items:baseline;gap:12px;padding:12px 0;font-size:14px">';
    h += '<span style="color:#6e6a68">Want one of each?</span>';
    h += '<button data-action="to-mix" style="background:none;border:none;padding:12px 0;margin:-12px 0;color:#151212;font-size:14px;white-space:nowrap;text-decoration:underline;text-underline-offset:4px;text-decoration-thickness:1px;font-family:inherit;cursor:pointer">Mix sizes</button>';
    h += '</div></div>';
  }
  h += '</div>';

  /* Mix mode */
  if(mixing){
    h += '<div style="display:flex;flex-direction:column;gap:12px">';
    h += '<div style="display:flex;justify-content:space-between;align-items:baseline;font-size:14px;color:#6e6a68"><span>Mix your cabinet</span><button data-action="to-simple" style="background:none;border:none;padding:12px 0;margin:-12px 0;color:#151212;font-size:14px;text-decoration:underline;text-underline-offset:4px;text-decoration-thickness:1px;font-family:inherit;cursor:pointer">Back to one size</button></div>';
    h += '<div style="display:flex;flex-direction:column;border-top:1px solid #c9cbd1">';
    for(var i=0;i<SIZES.length;i++){
      var isOut = STOCK[i]==='out';
      var fg = isOut?'#c9cbd1':'#151212';
      h += '<div style="display:grid;grid-template-columns:1fr auto;gap:16px;align-items:center;padding:12px 0;border-bottom:1px solid #c9cbd1">';
      h += '<div style="display:flex;flex-direction:column;gap:2px"><div style="display:flex;gap:10px;align-items:baseline"><span style="font-weight:700;font-size:16px;letter-spacing:-0.02em;color:'+fg+'">'+SIZES[i].label+'</span><span style="font-size:14px;color:#6e6a68">'+money(SIZES[i].price)+'</span></div><span style="font-family:\'Fragment Mono\',monospace;font-size:11px;letter-spacing:0.06em;color:#6e6a68">'+statusText(STOCK[i])+'</span></div>';
      h += '<div style="display:flex;align-items:center;border:1px solid '+fg+';border-radius:999px;overflow:hidden">';
      h += '<button data-action="dec" data-value="'+i+'" '+(isOut||S.mix[i]<=0?'disabled':'')+' style="width:44px;height:44px;background:none;border:none;color:'+fg+';font-family:\'Fragment Mono\',monospace;font-size:16px;cursor:pointer">\u2212</button>';
      h += '<span style="min-width:24px;text-align:center;font-weight:700;font-size:15px;color:'+fg+'">'+S.mix[i]+'</span>';
      h += '<button data-action="inc" data-value="'+i+'" '+(isOut?'disabled':'')+' style="width:44px;height:44px;background:none;border:none;color:'+fg+';font-family:\'Fragment Mono\',monospace;font-size:16px;cursor:pointer">+</button>';
      h += '</div></div>';
    }
    h += '</div></div>';
  } else {
    /* Simple mode tiers */
    h += '<div style="display:flex;flex-direction:column;gap:8px">';
    for(var i=0;i<3;i++){
      var q = i+1;
      var on = S.qty===i;
      var tt = round95(sz.price*q*(1-DISC[i]));
      var savePer = Math.max(0, sz.price*q - tt);
      var bg = on?'#151212':'transparent';
      var fg = on?'#f6f6f6':'#151212';
      var border = on?'1.5px solid #151212':'1px solid #c9cbd1';
      var subColor = on?'rgba(246,246,246,.7)':'#6e6a68';
      h += '<button data-action="select-tier" data-value="'+i+'" style="display:grid;grid-template-columns:auto 1fr auto;gap:14px;align-items:center;text-align:left;width:100%;padding:14px 16px;background:'+bg+';border:'+border+';border-radius:14px;color:'+fg+';transition:background 220ms cubic-bezier(.2,.6,.2,1);font-family:inherit;cursor:pointer">';
      h += '<span style="width:18px;height:18px;border-radius:50%;border:1.5px solid '+fg+';display:grid;place-items:center"><span style="width:8px;height:8px;border-radius:50%;background:'+fg+';opacity:'+(on?'1':'0')+'"></span></span>';
      h += '<span style="display:flex;flex-direction:column;gap:3px;min-width:0"><span style="display:flex;align-items:center;gap:8px;white-space:nowrap"><span style="font-weight:700;font-size:16px">'+q+(q===1?' tin':' tins')+'</span>'+(i===1?'<span style="font-size:12px;font-weight:500;padding:3px 9px;border-radius:999px;background:#b8d4e0;color:#151212;line-height:1.2">Most chosen</span>':'')+'</span><span style="font-size:14px;color:'+subColor+'">'+BLURB[i]+'</span></span>';
      h += '<span style="display:flex;flex-direction:column;align-items:flex-end;gap:2px"><span style="font-weight:700;font-size:16px">'+money(tt)+'</span><span style="font-family:\'Fragment Mono\',monospace;font-size:11.5px;letter-spacing:0.06em;color:'+subColor+';white-space:nowrap">'+(savePer>0.01?'Save '+money(savePer):money(sz.price)+' / tin')+'</span></span>';
      h += '</button>';
    }
    h += '</div>';
  }

  /* Save line + CTA */
  h += '<div style="display:flex;flex-direction:column;gap:8px;margin-top:-6px">';
  var saveLine = count===0?'PICK A TIN':save>0.01?'YOU SAVE '+money(save).toUpperCase()+' + FREE AU SHIPPING':count>=2?'FREE AU SHIPPING':'$6.95 AU SHIPPING \u00b7 FREE FROM TWO TINS';
  h += '<div style="text-align:center;font-family:\'Fragment Mono\',monospace;font-size:11.5px;letter-spacing:0.08em;text-transform:uppercase;color:#151212;padding:2px 0 6px">'+saveLine+'</div>';
  if(preIn&&count>0){
    var shipNote = mixing&&S.mix.filter(function(q){return q>0}).length>1 ? 'Ships together '+SHIP+', when the pre-order lands.' : 'Ships '+SHIP+'. Charged now, cancel any time before it leaves.';
    h += '<p style="margin:0;font-size:14px;color:#6e6a68;text-align:center">'+shipNote+'</p>';
  }

  var ctaLabel = (!mixing&&headOut) ? sz.label+' is sold out' : count===0 ? 'Add to cart' : (preIn?'Pre-order':'Add '+count+(count===1?' tin':' tins')+' to cart')+' \u00b7 '+money(total);
  var ctaBg = (disabled||preIn)?'transparent':'#151212';
  var ctaFg = disabled?'#c9cbd1':preIn?'#151212':'#f6f6f6';
  var ctaBorder = disabled?'1px solid #c9cbd1':preIn?'1.5px solid #151212':'1.5px solid #151212';
  h += '<button data-action="add-to-cart" '+(disabled?'disabled':'')+' style="width:100%;padding:18px 20px;background:'+ctaBg+';color:'+ctaFg+';border:'+ctaBorder+';border-radius:999px;font-size:15px;font-weight:500;font-family:inherit;cursor:pointer">'+ctaLabel+'</button>';

  /* Shop Pay (static display) */
  if(!disabled){
    h += '<button style="width:100%;padding:18px 20px;background:#5a31f4;color:#fff;border:none;border-radius:999px;font-size:15px;font-weight:500;font-family:inherit;cursor:pointer">Buy with <strong style="font-weight:800;letter-spacing:-0.02em">shop</strong></button>';
    h += '<div style="text-align:center;padding:2px 0"><a href="#" style="font-size:14px;color:#151212;border-bottom:1px solid #c9cbd1;text-decoration:none">More payment options</a></div>';
  }
  h += '</div>';

  /* Closing lines */
  h += '<div style="display:flex;flex-direction:column;gap:6px;font-size:14px;color:#3a3636;line-height:1.45">';
  h += '<p style="margin:0;text-wrap:pretty">30-day one-tin guarantee. If it doesn\u2019t earn a permanent spot in your bathroom, we refund one tin, minus shipping.</p>';
  h += '<p style="margin:0">Dispatched Mon, Wed, Fri. $6.95 AU shipping, free from two tins.</p>';
  h += '</div>';
  h += '</div>';

  el.innerHTML = h;

  /* Update final CTA section */
  renderFinalCTA(sz, st, count, total, preIn, disabled, mixing);
}

/* ─── Selector event delegation ────────────────────── */
function initSelector(){
  var el = $('#pdpv3-selector');
  if(!el) return;
  el.addEventListener('click', function(e){
    var btn = e.target.closest('[data-action]');
    if(!btn) return;
    var action = btn.dataset.action;
    var val = parseInt(btn.dataset.value);
    switch(action){
      case 'toggle-sizes': S.sizesOpen=!S.sizesOpen; break;
      case 'select-size': S.size=val; S.sizesOpen=false; S.mode='simple'; break;
      case 'select-tier': S.qty=val; break;
      case 'to-mix': S.mode='mix'; S.sizesOpen=false; break;
      case 'to-simple': S.mode='simple'; break;
      case 'inc': S.mix[val]=Math.min(6,S.mix[val]+1); break;
      case 'dec': S.mix[val]=Math.max(0,S.mix[val]-1); break;
      case 'add-to-cart':
        if(!btn.disabled){
          var items = S.mode==='mix'
            ? SIZES.map(function(z,i){return S.mix[i]?{id:parseInt(z.id),quantity:S.mix[i]}:null}).filter(Boolean)
            : [{id:parseInt(SIZES[S.size].id), quantity:S.qty+1}];
          fetch('/cart/add.js',{method:'POST',headers:{'Content-Type':'application/json'},body:JSON.stringify({items:items})})
            .then(function(r){return r.json()})
            .then(function(){window.location.href='/cart'})
            .catch(function(err){console.error('Cart error:',err)});
        }
        break;
    }
    renderSelector();
    renderMaths();
  });
}

/* ─── Gallery events ───────────────────────────────── */
function initGallery(){
  var container = $('#pdpv3-hero');
  if(!container) return;
  var heroImg = $('#pdpv3-hero-img');
  if(heroImg){
    heroImg.setAttribute('data-src0', heroImg.src);
    var srcs = document.querySelectorAll('[data-gallery]');
    srcs.forEach(function(t){
      var idx = parseInt(t.dataset.gallery);
      if(GALLERY_TYPES[idx]==='image'){
        var img = t.querySelector('img');
        if(img) heroImg.setAttribute('data-src'+idx, img.src);
      }
    });
  }
  document.addEventListener('click', function(e){
    var btn = e.target.closest('[data-gallery]');
    if(!btn) return;
    S.gallery = parseInt(btn.dataset.gallery);
    renderGallery();
  });
}

/* ─── Accordions (S1) ──────────────────────────────── */
function initAccordions(){
  document.addEventListener('click', function(e){
    var trigger = e.target.closest('[data-acc-trigger]');
    if(!trigger) return;
    var id = trigger.dataset.accTrigger;
    var panel = $('[data-acc-panel="'+id+'"]');
    if(!panel) return;
    var isOpen = panel.classList.contains('pdpv3-acc-panel--open');
    panel.classList.toggle('pdpv3-acc-panel--open');
    var glyph = trigger.querySelector('.pdpv3-mono');
    if(glyph) glyph.textContent = isOpen ? '+' : '\u2212';
  });
}

/* ─── "See all fifteen" link ───────────────────────── */
function initSeeAll(){
  var btn = $('#pdpv3-see-all-15');
  if(!btn) return;
  btn.addEventListener('click', function(){
    var panel = $('[data-acc-panel="acc-0"]');
    if(panel && !panel.classList.contains('pdpv3-acc-panel--open')){
      panel.classList.add('pdpv3-acc-panel--open');
      var trigger = $('[data-acc-trigger="acc-0"]');
      if(trigger){var g=trigger.querySelector('.pdpv3-mono');if(g)g.textContent='\u2212';}
    }
    var el = $('#acc-0');
    if(el) window.scrollTo({top: el.getBoundingClientRect().top+window.scrollY-24, behavior:'smooth'});
  });
}

/* ─── Tiles → Tabs (S3 → S12) ─────────────────────── */
function initTiles(){
  document.addEventListener('click', function(e){
    var btn = e.target.closest('[data-tile]');
    if(!btn) return;
    var tabIdx = parseInt(btn.dataset.tile);
    selectTab(tabIdx);
    var el = $('#case');
    if(el) window.scrollTo({top: el.getBoundingClientRect().top+window.scrollY-16, behavior:'smooth'});
  });
}

/* ─── Tabs (S12) ───────────────────────────────────── */
function selectTab(idx){
  $$('[data-tab]').forEach(function(btn){
    var i = parseInt(btn.dataset.tab);
    var on = i===idx;
    btn.style.background = on?'#151212':'transparent';
    btn.style.color = on?'#f6f6f6':'#151212';
    btn.style.border = on?'1.5px solid #151212':'1px solid #c9cbd1';
  });
  $$('[data-tab-panel]').forEach(function(p){
    var i = parseInt(p.dataset.tabPanel);
    p.style.display = i===idx?'grid':'none';
  });
}
function initTabs(){
  var container = $('#pdpv3-tabs');
  if(!container) return;
  container.addEventListener('click', function(e){
    var btn = e.target.closest('[data-tab]');
    if(!btn) return;
    selectTab(parseInt(btn.dataset.tab));
  });
}

/* ─── FAQ (S16) ────────────────────────────────────── */
function initFAQ(){
  document.addEventListener('click', function(e){
    var trigger = e.target.closest('[data-faq-trigger]');
    if(!trigger) return;
    var idx = trigger.dataset.faqTrigger;
    var panel = $('[data-faq-panel="'+idx+'"]');
    if(!panel) return;
    var isOpen = panel.classList.contains('pdpv3-acc-panel--open');
    panel.classList.toggle('pdpv3-acc-panel--open');
    var glyph = trigger.querySelector('.pdpv3-mono');
    if(glyph) glyph.textContent = isOpen?'+':'\u2212';
  });
}

/* ─── UGC Sound (S9) ──────────────────────────────── */
function initUGC(){
  document.addEventListener('click', function(e){
    var btn = e.target.closest('[data-ugc-sound]');
    if(!btn) return;
    var idx = parseInt(btn.dataset.ugcSound);
    var wasOn = S.sound===idx;
    /* Mute all */
    $$('[data-ugc]').forEach(function(v){v.muted=true});
    $$('[data-ugc-sound]').forEach(function(b){b.textContent='SOUND OFF'});
    if(!wasOn){
      var vid = $('[data-ugc="'+idx+'"]');
      if(vid){vid.muted=false; S.sound=idx;}
      btn.textContent = 'SOUND ON';
    } else {
      S.sound = -1;
    }
  });
}

/* ─── Maths (S8) ──────────────────────────────────── */
function renderMaths(){
  var sizesEl = $('#pdpv3-maths-sizes');
  var rightEl = $('#pdpv3-maths-right');
  var ledeEl = $('#pdpv3-maths-lede');
  if(!sizesEl||!rightEl) return;

  var mi = S.mathSize;
  var mz = SIZES[mi], mst = STOCK[mi];
  var perDay = mz.price / mz.days;
  var durations = ['seven weeks','three months or more','fourteen months'];

  if(ledeEl) ledeEl.textContent = money(mz.price)+' for the '+mz.label+' tin. Around '+durations[mi]+' at daily use. The four or five it usually replaces:';

  /* Size buttons */
  var sh = '';
  sh += '<div style="display:flex;flex-direction:column;gap:8px;max-width:360px">';
  for(var i=0;i<SIZES.length;i++){
    var on = i===mi;
    var inStk = STOCK[i]==='in'||STOCK[i]==='low';
    var bg = on?'#151212':'transparent';
    var fg = on?'#f6f6f6':'#151212';
    var border = on?'1.5px solid #151212':'1px solid #c9cbd1';
    var sub = on?'rgba(246,246,246,.7)':'#6e6a68';
    var dot = inStk?'#7fc97a':(on?'rgba(246,246,246,.4)':'#c9cbd1');
    sh += '<button data-maths-size="'+i+'" style="display:grid;grid-template-columns:auto 1fr auto;gap:14px;align-items:center;text-align:left;width:100%;min-height:52px;padding:0 16px;border:'+border+';border-radius:14px;background:'+bg+';color:'+fg+';font-size:16px;font-weight:700;transition:background 220ms cubic-bezier(.2,.6,.2,1);font-family:inherit;cursor:pointer">';
    sh += '<span style="width:18px;height:18px;border-radius:50%;border:1.5px solid '+fg+';display:grid;place-items:center"><span style="width:8px;height:8px;border-radius:50%;background:'+fg+';opacity:'+(on?'1':'0')+'"></span></span>';
    sh += '<span>'+SIZES[i].label+' tin</span>';
    sh += '<span style="display:flex;align-items:center;gap:6px;font-family:\'Fragment Mono\',monospace;font-size:11px;letter-spacing:0.06em;font-weight:400;color:'+sub+';white-space:nowrap"><span style="width:6px;height:6px;border-radius:50%;background:'+dot+'"></span>'+statusText(STOCK[i])+'</span>';
    sh += '</button>';
  }
  sh += '</div>';
  sizesEl.innerHTML = sh;

  /* Right column: rows */
  var rows = [['Lip balm','$0.43/day'],['Hand cream','$1.07/day'],['Barrier-repair ointment','$0.57/day'],['Cuticle oil','$0.43/day'],['Post-shave balm','$0.43/day']];
  var rh = '<div style="display:flex;flex-direction:column;border-top:1px solid #151212">';
  for(var r=0;r<rows.length;r++){
    rh += '<div style="display:flex;justify-content:space-between;gap:16px;padding:12px 0;border-bottom:1px solid #c9cbd1"><span>'+rows[r][0]+'</span><span style="font-family:\'Fragment Mono\',monospace;font-size:14px;letter-spacing:0.04em">'+rows[r][1]+'</span></div>';
  }
  rh += '<div style="display:flex;justify-content:space-between;gap:16px;padding:14px 0;border-bottom:1px solid #151212;font-weight:700"><span>Those five</span><span style="font-family:\'Fragment Mono\',monospace;font-size:14px;letter-spacing:0.04em">$2.93/day</span></div>';
  var balmLabel = 'The Everywhere Balm, '+mz.label+(mst==='preorder'?' (pre-order)':'');
  rh += '<div style="display:flex;justify-content:space-between;gap:16px;padding:14px 0;border-bottom:1px solid #151212;font-weight:700"><span>'+balmLabel+'</span><span style="font-family:\'Fragment Mono\',monospace;font-size:14px;letter-spacing:0.04em">$'+perDay.toFixed(2)+'/day</span></div>';
  rh += '</div>';

  /* Drawer toggle + CTA */
  rh += '<div style="display:flex;align-items:center;justify-content:space-between;gap:16px;flex-wrap:wrap">';
  rh += '<button data-action-maths="toggle-drawer" style="background:none;border:none;padding:12px 0;color:#151212;font-size:15px;text-decoration:underline;text-underline-offset:4px;text-decoration-thickness:1px;font-family:inherit;cursor:pointer">'+(S.drawer?'Close the drawer':'See the whole drawer')+'</button>';
  rh += '<a href="#pdpv3-s1" class="pdpv3-cta" style="font-size:15px">Retire the drawer</a>';
  rh += '</div>';

  /* Drawer */
  if(S.drawer){
    rh += '<ol style="display:flex;flex-direction:column;border-top:1px solid #c9cbd1;font-size:15px">';
    for(var d=0;d<REPLACES.length;d++){
      rh += '<li style="display:grid;grid-template-columns:32px minmax(0,1fr);gap:12px;padding:9px 0;border-bottom:1px solid #c9cbd1"><span style="font-family:\'Fragment Mono\',monospace;font-size:11.5px;letter-spacing:0.08em;color:#6e6a68;padding-top:3px">'+String(d+1).padStart(2,'0')+'</span><span>'+REPLACES[d]+'</span></li>';
    }
    rh += '</ol>';
  }

  rh += '<p style="margin:0;font-size:13px;line-height:1.5;color:#6e6a68;text-wrap:pretty">Daily costs are representative Australian retail prices at typical use, for comparison only.</p>';
  rightEl.innerHTML = rh;
}

function initMaths(){
  var el = $('#pdpv3-maths-right');
  var sizesEl = $('#pdpv3-maths-sizes');
  if(!el) return;
  document.addEventListener('click', function(e){
    var sizeBtn = e.target.closest('[data-maths-size]');
    if(sizeBtn){S.mathSize=parseInt(sizeBtn.dataset.mathsSize);renderMaths();return;}
    var actionBtn = e.target.closest('[data-action-maths]');
    if(actionBtn){
      if(actionBtn.dataset.actionMaths==='toggle-drawer'){S.drawer=!S.drawer;renderMaths();}
    }
  });
}

/* ─── Final CTA (S17) ─────────────────────────────── */
function renderFinalCTA(sz,st,count,total,preIn,disabled,mixing){
  var titleEl = $('#pdpv3-final-title');
  var dotEl = $('#pdpv3-final-dot');
  var statusEl = $('#pdpv3-final-status');
  var btnEl = $('#pdpv3-final-btn');
  if(!titleEl) return;
  if(!sz){sz=SIZES[S.size];st=STOCK[S.size]}
  if(count===undefined){
    mixing = S.mode==='mix';
    count = mixing ? S.mix.reduce(function(a,b){return a+b},0) : S.qty+1;
    var sub = mixing ? S.mix.reduce(function(a,q,i){return a+q*SIZES[i].price},0) : sz.price*(S.qty+1);
    var rate = mixing ? rateFor(count) : DISC[S.qty];
    total = count ? round95(sub*(1-rate)) : 0;
    preIn = mixing ? S.mix.some(function(q,i){return q>0&&STOCK[i]==='preorder'}) : st==='preorder';
    disabled = count===0;
  }
  titleEl.textContent = mixing ? 'Mixed \u00b7 '+count+(count===1?' tin':' tins') : (S.qty+1)+' \u00d7 '+sz.label+(S.qty?' tins':' tin');
  if(dotEl) dotEl.style.background = (st==='in'||st==='low')?'#a8b8a0':'rgba(255,255,255,.28)';
  if(statusEl) statusEl.textContent = mixing ? (preIn?'Includes pre-order':'In stock') : statusText(st);
  if(btnEl){
    btnEl.textContent = disabled?'Sold out':(preIn?'Pre-order':'Add '+count+(count===1?' tin':' tins')+' to cart')+' \u00b7 '+money(total);
    btnEl.disabled = disabled;
  }
}

/* ─── Sticky Bar ───────────────────────────────────── */
function initSticky(){
  var sticky = $('#pdpv3-sticky');
  var target = $('#pdpv3-selector');
  if(!sticky||!target) return;
  var observer = new IntersectionObserver(function(entries){
    entries.forEach(function(entry){
      if(entry.isIntersecting){
        sticky.classList.remove('pdpv3-sticky--visible');
      } else {
        sticky.classList.add('pdpv3-sticky--visible');
      }
    });
  }, {threshold:0});
  observer.observe(target);
}

/* ─── Init ─────────────────────────────────────────── */
function init(){
  renderSelector();
  initSelector();
  initGallery();
  renderGallery();
  fitTitle();
  initAccordions();
  initSeeAll();
  initTiles();
  initTabs();
  initFAQ();
  initUGC();
  renderMaths();
  initMaths();
  initSticky();

  window.addEventListener('resize', function(){fitTitle()});
  if(document.fonts&&document.fonts.ready) document.fonts.ready.then(function(){fitTitle()});
}

if(document.readyState==='loading'){
  document.addEventListener('DOMContentLoaded', init);
} else {
  init();
}
})();
